<template>
  <div class="wrapper">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              알림 발송
            </div>
          </section>
          <!-- 메일 활성(Class) : mailActive / SMS 활성(Class) : smsActive -->
          <section class="section02" :class="alarmClass">
            <div class="object01"></div>
            <div class="object02">
              발송 일시
            </div>
            <div class="object03">
              {{ alarmInfo !== null ? alarmInfo.alarm_send_datetime.substring(16,0) : ''}}
            </div>
            <div class="object04"></div>
            <div class="object05">
              발송 상태
            </div>
            <!-- 발송 실패(Class) : failure -->
            <div class="object06" :class="alarmInfo !== null && alarmInfo.status === 'fail' ? 'failure' : ''">
              {{ alarmInfo !== null ? findStatusName(alarmInfo.status) : ''}}
            </div>
            <div class="object07"></div>
            <div class="object08">
              수신 인원
            </div>
            <div class="object09">
              {{ alarmInfo !== null && alarmInfo.recept_cnt ? alarmInfo.recept_cnt : 0 }}/{{ alarmInfo !== null && alarmInfo.target_list_name ? alarmInfo.target_list_name.split(',').length : '0'}}
            </div>
            <div class="object10"></div>
            <div class="object11">
              대상
            </div>
            <div class="object12">
              {{ alarmInfo !== null ? alarmInfo.target_all_yn ? '전체' : alarmInfo.target_list_name ? alarmInfo.target_list_name : '없음' : '없음'}}
            </div>
            <div class="object1301">
              <div class="object13"></div>
              <div class="object14">
                알림 종류
              </div>
              <div class="object15">
                {{ alarmInfo !== null ? alarmInfo.alarm_method : ''}}
              </div>
              <div class="object16"></div>
            </div>
          </section>
          <section class="section03 sms">
            <div class="object01"></div>
            <div class="object02">
              SMS 내용
            </div>
            <div class="object03" v-html="alarmInfo !== null ? replaceNewLine(alarmInfo.content) : ''">
            </div>
            <div class="object04"></div>
          </section>
          <section class="section03 mail">
            <div class="object01"></div>
            <div class="object02">
              이메일 제목
            </div>
            <div class="object03">
              {{ alarmInfo !== null ? alarmInfo.email_title : ''}}
            </div>
            <div class="object04"></div>
          </section>
          <section class="section04 sms">
            <div class="object01"></div>
            <div class="object02">
              등록/수정일시
            </div>
            <div class="object03">
              {{ alarmInfo !== null ? alarmInfo.isrt_dt : ''}}
            </div>
          </section>
          <section class="section04 mail">
            <div class="object01"></div>
            <div class="object02">
              이메일 내용
            </div>
            <div class="object03">
              <div class="item02" v-html="alarmInfo !== null ? replaceNewLine(alarmInfo.content) : ''">
              </div>
            </div>
            <div class="object04"></div>
          </section>
          <section class="section05">
            <div class="object01"></div>
            <div class="object02">
              등록/수정일시
            </div>
            <div class="object03">
              {{ alarmInfo !== null ? alarmInfo.updt_dt ? alarmInfo.updt_dt.substr(0,16) : alarmInfo.isrt_dt.substr(0,16) : ''}}
            </div>
          </section>
          <!-- 발송 예정(Class) : schedule / 발송 실패(Class) : failure -->
          <section class="section06" :class="statusClass">
            <div class="object01" @click="moveMenu('SE201')">
              목록
            </div>
            <div class="object02" @click="moveMenu('SE204?alarm_id=' + alarmId)">
              수정하기
            </div>
            <div class="object03" @click="confirmResend">
              재발송
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div :class="beforeConfirm ? 'alert' : 'alert typeConfirm'">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body" v-html="alertBodyHTML">
                  </div>
                  <div class="footer">
                    <button class="cancel" @click="closeAndCancelAlert">
                      취소
                    </button>
                    <button class="confirm" @click="closeAlert">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'
import {settingService, userService} from '../../router'

export default {
  name: 'SE202',
  data () {
    return {
      beforeConfirm: true,
      callback: null,
      alarmInfo: null,
      alarmId: '',
      alertBodyHTML: '',
      statusList: [
        {name: '발송 예정', code: 'ready'},
        {name: '발송중', code: 'process'},
        {name: '발송 실패', code: 'fail'},
        {name: '발송 완료', code: 'complete'}
      ]
    }
  },
  created: function () {
    userService.getAll().then(response => {
      this.userInfo = response.data
    })
    this.alarmId = this.$route.query.alarm_id
  },
  mounted: function () {
    this.setData(this.alarmId)
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  methods: {
    setData: function (alarmId) {
      settingService.getAlarm(alarmId).then(response => {
        this.alarmInfo = response.data.alarm
      })
    },
    findStatusName: function (status) {
      if (this.statusList.find(it => it.code === status) !== undefined) {
        return this.statusList.find(it => it.code === status).name
      } else {
        return ''
      }
    },
    openAlert: function (html, cb = null) {
      this.alertBodyHTML = html
      this.callback = cb
      document.querySelector('body.type-content').classList.add('alertActive')
    },
    closeAndCancelAlert: function () {
      this.alertBodyHTML = ''
      document.querySelector('body.type-content').classList.remove('alertActive')
      if (this.callback === null) return
      this.callback = null
    },
    confirmResend: function () {
      this.beforeConfirm = true
      this.alertBodyHTML = '해당 알림을<br />지금 재발송 하시겠습니까?'
      this.openAlert(this.alertBodyHTML, function () {
        this.resendAlarm()
      })
    },
    closeAlert: function () {
      this.alertBodyHTML = ''
      document.querySelector('body.type-content').classList.remove('alertActive')
      if (this.callback === null) return
      this.callback()
    },
    resendAlarm: function () {
      this.beforeConfirm = false
      settingService.resendAlarm(this.alarmId).then(response => {
        if (response.statusCode === 200) {
          this.openAlert('알림 재발송이 진행됩니다.', function () {
            location.reload()
          })
        }
      }).catch(e => {
        console.log(e)
        this.openAlert('오류가 발생했습니다.<br />다시 시도해주세요.')
      })
    }
  },
  computed: {
    alarmClass: function () {
      if (this.alarmInfo === null) return {}
      return {
        smsActive: this.alarmInfo.alarm_method === 'sms',
        mailActive: this.alarmInfo.alarm_method === 'email'
      }
    },
    statusClass: function () {
      if (this.alarmInfo === null) return {}
      return {
        schedule: this.alarmInfo.status === 'ready',
        failure: this.alarmInfo.status === 'fail'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/setting/SE202.vue